<template>
  <div>
    <Loader v-if="orderWatchlist.length == 0" />
    <div class="dashboard__container--body" v-if="orderWatchlist.length > 0">
      <vue-good-table
        :columns="columns"
        :rows="orderWatchlist"
        styleClass="vgt-table striped"
        :search-options="{
          enabled: true,
          placeholder: 'Search this table',
        }"
        :pagination-options="{
          enabled: true,
          mode: 'records',
          perPage: 25,
        }"
        >
        <template slot="table-row" slot-scope="props">
              <span v-if="props.column.field == 'created'">
                <span v-if="props.row.created">{{formatDate(props.row.created)}}</span>
              </span>
              <span v-else-if="props.column.field == 'title'">
                <router-link :to="`/events/` + props.row.id">
                  {{props.row.title}}
                </router-link>
              </span>
               <span v-else-if="props.column.field == 'watchlist'">
           <button v-if="isWatchList(props.row)" class="btn btn__icon" @click="removeWatch(props.row)"><i class="fa-solid fa-star warning"></i></button>
        </span>
              <span v-else-if="props.column.field == 'visible'">
                <i class="fa-solid fa-check" v-if="props.row.visible" style="color:green;"></i>
              </span>
              <span v-else-if="props.column.field == 'client'">
                <span v-if="props.row.venue.client && props.row.venue.client[0]">
                  {{props.row.venue.client[0].title}}
                </span>
              </span>
              <span v-else-if="props.column.field == 'groups'">
                <span v-if="!props.row.groups || props.row.groups.length == 0">
                  <i class="fa-solid fa-user-group ml-2 mr-2" style="opacity:50%;"></i>
                </span>
                <span v-if="props.row.groups && props.row.groups.length > 0">
                  <v-popover>
                    <i class="fa-solid fa-user-group ml-2 mr-2 blueHue"></i>
                    <template slot="popover">
                      <span v-for="z in props.row.groups">{{z}} / </span>
                    </template>
                  </v-popover>
                </span>
                <!-- <span v-if="props.row.groups && props.row.groups.length >= 1">
                  <button class="chipDark mb-1" v-for="(item, index) in props.row.groups" :key="index">{{item.title}}</button>
                </span> -->
              </span>
              <span v-else>
                {{props.formattedRow[props.column.field]}}
              </span>
            </template>
      </vue-good-table>
    </div>  
  </div>
</template>

<script>
import * as moment from 'moment'
import { mapState } from 'vuex'
import Loader from '@/components/Loader.vue'
// import ExportService from "@/services/ExportService"
import router from '@/router'

export default {
  name: 'orderWatchlist',
  data() {
    return {
      columns: [
      {
        label: 'Start Date',
        field: 'startDate',
      },
      {
        label: 'Watchlist',
        field: 'watchlist',
        tdClass: 'text-center-all',
        width: '80px'
      },
      {
        label: 'Title',
        field: 'title',
      },
      {
        label: 'Order #',
        field: 'jobNum',
        width: '100px'
      },
      {
        label: 'PO/Ref',
        field: 'refNum',
        width: '100px'
      },
      {
        label: 'Client',
        field: 'client',
      },
      {
        label: 'City',
        field: 'event_city',
      },
      {
        label: 'State',
        field: 'event_state',
      },
      {
        label: 'Venue',
        field: 'venue_title',
      },
      {
        label: 'Groups',
        field: 'groups',
      },
      {
        label: 'Published',
        field: 'visible',
      },
    ],
    };
  },
  computed: {
    ...mapState(['currentUser', 'userProfile', 'orderWatchlist']),
  },
  components: {
    Loader,
  },
  created () {
    if (!this.orderWatchlist || this.orderWatchlist.length < 1) {
      this.$store.dispatch("getOrderWatchlist")
    }
  },
  methods: {
    isWatchList(row) {
      if (this.userProfile && this.userProfile.orderWatchList && this.userProfile.orderWatchList.includes(row.id)) {
        return true
      } else {
        return false
      }
    },
    async removeWatch(row) {
      await this.$store.dispatch('unWatchOrder', row.id)
    },
    formatDate(q) {
      if(q) {
        const postedDate = new Date(q.seconds) * 1000;
        return moment(postedDate).format('MMMM Do YYYY')
      } else {
        return null
      }
    },
  },
}
</script>